module.exports = __webpack_public_path__ + "img/dark-mud-decal-12.5db8a9c2.png";